import { DeleteProject } from '@/connection/projects/delete-project';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectsReducerCreator } from '../types';

const deleteProjectReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (projectUuid: string, { rejectWithValue }) => {
      try {
        const deletedProject = await DeleteProject(projectUuid);
        return deletedProject;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.projectGroups) {
          state.projectGroups = state.projectGroups.map((pg) => ({
            ...pg,
            event_uuids: pg.event_uuids.filter((uuid) => uuid !== action.payload.uuid),
          }));

          const isOnlyProjectForGroup = state.projectGroups.filter(
            (pg) => pg.event_uuids.length === 1 && pg.event_uuids[0] === action.payload.uuid
          );

          if (isOnlyProjectForGroup.length) {
            state.selectedProjectGroup = '';
            state.projectGroups = [];
          }
        }

        state.projectToDelete = null;
      },
      rejected: (state, action) => {
        console.error(action.payload || action.error);
        state.projectsError = true;
        toastTrigger('There was an error deleting your project. Please refresh the page.', {
          type: 'error',
          autoClose: 10000,
        });
      },
    }
  );
};

export default deleteProjectReducer;
